var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1601_3792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2807 6.42667L13.8987 5.80867C14.3903 5.31705 14.6665 4.65027 14.6665 3.95501C14.6665 3.25975 14.3903 2.59296 13.8987 2.10134C13.407 1.60972 12.7403 1.33353 12.045 1.33353C11.3497 1.33353 10.683 1.60972 10.1913 2.10134L9.57334 2.71934L3.892 8.39934C3.50734 8.78467 3.31467 8.97734 3.14934 9.18934C2.95426 9.43966 2.78685 9.71034 2.65 9.99667C2.53467 10.2393 2.44867 10.498 2.27667 11.014L1.54734 13.2013M13.2807 6.42667C13.2807 6.42667 11.968 6.34934 10.8093 5.19067C9.65067 4.03267 9.574 2.71934 9.574 2.71934M13.2807 6.42667L7.6 12.1067C7.21534 12.4913 7.02267 12.684 6.81067 12.8493C6.56035 13.0444 6.28967 13.2118 6.00334 13.3487C5.76067 13.464 5.50267 13.55 4.986 13.722L2.79867 14.4513M2.79867 14.4513L2.264 14.63C2.13937 14.6718 2.00556 14.678 1.87759 14.6479C1.74963 14.6178 1.6326 14.5526 1.53965 14.4597C1.4467 14.3667 1.38152 14.2497 1.35143 14.1218C1.32134 13.9938 1.32754 13.86 1.36934 13.7353L1.548 13.2007L2.79867 14.4513Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1601_3792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.1229e70dbd9cd4e04d89e4dc56171fd2.svg";
export { ForwardRef as ReactComponent };